var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndexImg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 100,
    viewBox: "0 0 120 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1810 -1576)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 100,
    transform: "translate(-1810 1576)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2605.29 -62.608)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(868.664 1647.608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.916,18.419A3.479,3.479,0,1,1,69.437,21.9a3.479,3.479,0,0,1,3.479-3.479",
    transform: "translate(-55.11 2.078)",
    fill: "#ffec00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.36,3.427a21.277,21.277,0,0,1,14.934,6.2,1.725,1.725,0,1,0,2.154-2.687,24.5,24.5,0,0,0-34.176,0,1.725,1.725,0,1,0,2.154,2.687,21.277,21.277,0,0,1,14.934-6.2",
    transform: "translate(-56.563)",
    fill: "#ffec00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.867,9.588a14.444,14.444,0,0,1,9.9,4.008c1.993,1.876,3.92-.51,2.614-2.238a17.653,17.653,0,0,0-25.02,0c-1.306,1.728.621,4.114,2.614,2.238a14.444,14.444,0,0,1,9.9-4.008",
    transform: "translate(-56.07 0.695)",
    fill: "#ffec00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.381,15.748a7.572,7.572,0,0,1,5.24,2.187,1.726,1.726,0,1,0,2.15-2.685,10.788,10.788,0,0,0-14.78,0,1.726,1.726,0,1,0,2.15,2.685,7.572,7.572,0,0,1,5.24-2.187",
    transform: "translate(-55.584 1.39)",
    fill: "#ffec00",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 6.495,
    height: 2.773,
    transform: "translate(828.884 1668.285)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.495,
    height: 2.773,
    transform: "translate(828.884 1677.814)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.495,
    height: 2.773,
    transform: "translate(828.884 1687.343)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.495,
    height: 2.773,
    transform: "translate(846.34 1668.285)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.495,
    height: 2.773,
    transform: "translate(846.34 1677.814)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.495,
    height: 2.773,
    transform: "translate(846.34 1687.343)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.495,
    height: 2.773,
    transform: "translate(828.884 1696.873)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.495,
    height: 2.773,
    transform: "translate(828.884 1706.403)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.494,
    height: 2.773,
    transform: "translate(875.958 1687.304)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.494,
    height: 2.773,
    transform: "translate(875.958 1696.833)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.494,
    height: 2.773,
    transform: "translate(875.958 1706.362)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.495,
    height: 2.773,
    transform: "translate(846.34 1696.873)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.495,
    height: 2.773,
    transform: "translate(846.34 1706.403)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.475,83.23H12.04c-.766,0-1.387-.239-1.387-1V10.056A1.386,1.386,0,0,1,12.04,8.67H55.475a1.386,1.386,0,0,1,1.387,1.386v72.17c0,.765-.621,1-1.387,1m-42.049-2H54.089V11.441H13.426Z",
    transform: "translate(807.29 1647.608)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.945,83.289H60.374v-2H82.558V34.227H60.374V31.454H83.945a1.387,1.387,0,0,1,1.387,1.387V82.284c0,.766-.621,1.005-1.387,1.005",
    transform: "translate(807.29 1647.549)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.05,83.289H28.465c-.766,0-1.386-.239-1.386-1.005V69.048a1.386,1.386,0,0,1,1.386-1.387H39.05a1.387,1.387,0,0,1,1.387,1.387V82.284c0,.766-.621,1.005-1.387,1.005m-9.2-2.392h7.812V70.434H29.852Z",
    transform: "translate(807.29 1647.549)",
    fill: "#00aeff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 2.77,
    transform: "translate(807.29 1728.838)",
    fill: "#00aeff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndexImg03);
export default __webpack_public_path__ + "static/media/index-img-03.4be1d9896a0c3d435836598850b9b87b.svg";
export { ForwardRef as ReactComponent };